module.exports = __webpack_public_path__ + "static/img/kong.9e40c7e0.png";